module.exports = __webpack_public_path__ + "img/tumyan.dd1874a6.jpg";